import { render, staticRenderFns } from "./WebAppEvents.vue?vue&type=template&id=303eabe8&scoped=true&"
import script from "./WebAppEvents.vue?vue&type=script&lang=js&"
export * from "./WebAppEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303eabe8",
  null
  
)

export default component.exports